// src/components/AudioPlayer/AudioPlayerApp.js
import React, { useState, useEffect } from 'react';
import YouTubeAudioPlayer from './YouTubeAudioPlayer';
import './AudioPlayer.css';

const DEFAULT_TRACKS = [
  { name: 'Coffee Shop Vibes', url: 'https://www.youtube.com/watch?v=hoX_NS0htBQ' },
  { name: '8 Hours Of The Best Classical Music', url: 'https://www.youtube.com/watch?v=T_Dy9OvgjHY' }
  
];

function AudioPlayerApp() {
  const [selectedTrack, setSelectedTrack] = useState(DEFAULT_TRACKS[0]);
  const [videoId, setVideoId] = useState(null);
  const [visualizerType, setVisualizerType] = useState('pulse');
  const [isVisualizerEnabled, setVisualizerEnabled] = useState(true);
  const [youtubeUrl, setYoutubeUrl] = useState('');
  const [showHelp, setShowHelp] = useState(false);


  const extractVideoId = (url) => {
    const regex = /(?:youtube\.com\/.*[?&]v=|youtu\.be\/)([^&\n?#]+)/;
    const matches = url.match(regex);
    return matches ? matches[1] : null;
  };

  useEffect(() => {
    const id = extractVideoId(selectedTrack.url);
    setVideoId(id);
  }, [selectedTrack]);

  const handleLoadVideo = () => {
    const id = extractVideoId(youtubeUrl);
    if (id) {
      setSelectedTrack({ name: "Custom", url: youtubeUrl });
      setVideoId(id);
    } else {
      alert('Please enter a valid YouTube URL.');
    }
  };

  return (
    <div className="AudioPlayerApp">

      <div className="card">
      <h1>Pulse</h1>
        <div className="input-section">
          <input
            type="text"
            placeholder="Enter YouTube video URL"
            value={youtubeUrl}
            onChange={(e) => setYoutubeUrl(e.target.value)}
          />
          <button onClick={handleLoadVideo}>Load YouTube Audio</button>
        </div>
      </div>

      <div className="card">
        <div className="audio-list">
          <h2>Select a Track:</h2>
          <select
            onChange={(e) => {
              const track = DEFAULT_TRACKS.find(t => t.url === e.target.value);
              if (track) setSelectedTrack(track);
            }}
            value={selectedTrack.url}
          >
            {DEFAULT_TRACKS.map((track, index) => (
              <option key={index} value={track.url}>{track.name}</option>
            ))}
          </select>
        </div>
      </div>

      <div className="card">
        <div className="visualizer-controls">
        <h2>Select a visual:</h2>
          <select
            id="visualizerType"
            onChange={(e) => setVisualizerType(e.target.value)}
            value={visualizerType}
          >
            <option value="pulse">Pulse</option>
            <option value="bars">Bars</option>
            <option value="waves">Waves</option>
            <option value="circle">Circle</option>
            <option value="dots">Dots</option>
            <option value="spectrum">Spectrum</option>
          </select>
          <label>
            <input
              type="checkbox"
              checked={isVisualizerEnabled}
              onChange={() => setVisualizerEnabled(!isVisualizerEnabled)}
            />
            Enable Visualizer
          </label>
        </div>
      </div>

      {videoId && (
        <YouTubeAudioPlayer
          videoId={videoId}
          visualizerType={visualizerType}
          isVisualizerEnabled={isVisualizerEnabled}
        />
      )}
    </div>
  );
}

export default AudioPlayerApp;